// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-03cf4f9e]{font-size:38px!important;font-family:outfit-semi-bold,serif}.image[data-v-03cf4f9e]{width:105px}.h4[data-v-03cf4f9e]{line-height:1.44;margin:12px}", ""]);
// Exports
module.exports = exports;
